import {
  getDownloadURL,
  ref,
  uploadBytes,
  uploadString,
} from 'firebase/storage';
import { storage } from '../../../../firebase';

export const uploadImages = async (images: string[], path: string) =>
  Promise.all(
    (images || []).map(async (image, index) => {
      if (!image?.startsWith('data:')) return image;

      const target = ref(storage!, `${path}/${Date.now()}-${index}`);
      await uploadString(target, image, 'data_url');
      return getDownloadURL(target);
    }),
  );

export const uploadAttachments = async (files: File[], path: string) =>
  Promise.all(
    (files || []).map(async (file, index) => {
      const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '-');
      const target = ref(storage!, `${path}/${Date.now()}-${index}-${safeName}`);

      await uploadBytes(target, file, {
        contentType: file.type || 'application/octet-stream',
      });

      return {
        url: await getDownloadURL(target),
        path: target.fullPath,
        name: file.name,
        type: file.type || 'application/octet-stream',
        size: file.size,
      };
    }),
  );
